import axios from 'axios';
import { getRandomString } from '../utils';

export const getS3UploadPathType = fileType => (fileType === 'file' ? 'files' : fileType);

const CONTENT_TYPES_BY_EXTENSION = {
	csv: 'text/csv',
	doc: 'application/msword',
	docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	gif: 'image/gif',
	jpeg: 'image/jpeg',
	jpg: 'image/jpeg',
	json: 'application/json',
	pdf: 'application/pdf',
	png: 'image/png',
	svg: 'image/svg+xml',
	txt: 'text/plain',
	webp: 'image/webp',
	xls: 'application/vnd.ms-excel',
	xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

const getContentType = (file, fileType) => (
	file.type || CONTENT_TYPES_BY_EXTENSION[String(fileType || '').toLowerCase()] || 'application/octet-stream'
);

const getAuthHeaders = () => ({
	authorization: `JWT ${localStorage.getItem('token')}`,
});

const getUploadErrorDetails = error => ({
	status: error?.response?.status || null,
	message: error?.response?.data?.error || error?.response?.data?.message || error?.message || 'Unknown error',
});

const serverUpload = async ({ endpoint, file, fileName, fileType, contentType, s3Path }) => {
	const formData = new FormData();
	formData.append('file', file);
	formData.append('fileName', fileName);
	formData.append('fileType', fileType);
	formData.append('contentType', contentType);
	formData.append('s3Path', s3Path);

	const response = await axios.post(`${endpoint}/upload_s3`, formData, {
		headers: getAuthHeaders(),
	});

	return response?.data?.data?.returnData?.url || response?.data?.url || '';
};

// should be in web as uses window!
// uploads file to s3 and returns file url
// fileName: will be generated if null passed; original file name will be used if undefined;
export const s3upload = async (file, fileName = undefined, s3Path = '', getServerEndpoint) => {
	try {
		const fileParts = file.name.split('.');

		fileName = fileName || (fileName === undefined ? [...fileParts].slice(0, -1).join('.') : getRandomString(50));
		const fileType = fileParts[fileParts.length - 1];

		const endpoint = await getServerEndpoint();
		const requestUrl = `${endpoint}/sign_s3`;
		const contentType = getContentType(file, fileType);

		const response = await axios.post(
			requestUrl, {
				fileName,
				fileType,
				contentType,
				s3Path,
			},
			{
				headers: getAuthHeaders(),
			},
		);

		const { returnData } = response.data.data;
		const { signedRequest } = returnData;
		const { url } = returnData;

		const options = {
			headers: {
				'Content-Type': contentType,
			},
		};

		try {
			await axios.put(signedRequest, file, options);
		}
		catch (directUploadError) {
			console.log('Direct S3 upload failed; retrying through server', getUploadErrorDetails(directUploadError));
			return serverUpload({ endpoint, file, fileName, fileType, contentType, s3Path });
		}

		return url;
	}
	catch (e) {
		console.log('S3 upload failed', getUploadErrorDetails(e));
		return '';
	}
};
